import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import PainPointsSection from "@/components/PainPointsSection";
import ModulesSection from "@/components/ModulesSection";
import CredibilitySection from "@/components/CredibilitySection";
import FinalCTASection from "@/components/FinalCTASection";
import FooterSection from "@/components/FooterSection";

function App() {
  return (
    <div className="min-h-screen bg-[#111111] relative">
      <Header />
      <main>
        <HeroSection />
        <PainPointsSection />
        <ModulesSection />
        <CredibilitySection />
        <FinalCTASection />
      </main>
      <FooterSection />
    </div>
  );
}

export default App;
